/*
  ═══════════════════════════════════════════════════════
  MONTAGE · Warenkorb an den Tag Manager melden
  ═══════════════════════════════════════════════════════
  Warum es das gibt (23.09.2026): Die Stufen legen mehrere Zeilen auf einmal
  ein (`items[]`, siehe snippets/mt-produkt-stufen.liquid). Für diesen Fall
  sendet Shopify KEIN `product_added_to_cart`. Befund der Tracking-Agentur,
  23.09.2026: „Beim Straw ist der Warenkorb Button mit diesem Bundle nicht
  standardmäßig konfiguriert, deshalb misst es nur add_to_cart beim
  Einzelprodukt." Folge: Warenkorb je Seitenaufruf, unsere wichtigste
  Frühzahl, ist für alle Stufenangebote blind.

  Was es tut: Es hört auf Dawns eigene Meldung `cartUpdate`, die
  `product-form.js` nach jedem erfolgreichen Einlegen sendet, und schreibt
  daraus ein Ereignis in den Datenschicht (`dataLayer`). Die Agentur macht
  daraus Metas AddToCart, im Browser und über den Server, dedupliziert über
  `event_id`.

  🔴 Was es NICHT tut: einlegen, Formulare bauen, fetch gegen /cart/add.
     EINGRIFFSREGELN.md § 2.2 bleibt gewahrt: Shopifys Produktformular,
     `<product-form>`, `product-form.js` und `routes.cart_add_url` werden
     nicht ersetzt und nicht nachgebaut. Dieses Skript liest nur mit.

  ⚠️ Für die Agentur: Das Ereignis feuert bei JEDEM Einlegen über das
     Produktformular, also auch beim Einzelprodukt, wo Shopifys eigenes
     Ereignis zusätzlich kommt. Entweder dieses hier verwenden und Shopifys
     Standard-Ereignis in der Zuordnung weglassen, oder auf
     `mt_mehrzeilig: true` filtern und nur die Stufen darüber senden.
     Doppelt zählen darf es nicht.

  Feld für Feld:
    event          "add_to_cart"
    event_id       Kennung für die Deduplizierung Browser gegen Server
    mt_quelle      "produktformular"
    mt_mehrzeilig  true, wenn mehrere Zeilen auf einmal eingelegt wurden
    ecommerce.currency / .value / .items[]  Inhalt, Menge, Wert in Euro
  ═══════════════════════════════════════════════════════
*/

(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  function kennung() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (fehler) {
      // Ältere Browser kennen randomUUID nicht: dann reicht eine eigene Kennung,
      // sie muss nur je Ereignis einmalig sein.
    }
    return 'mt-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function zeilen(daten) {
    // Eine Zeile: /cart/add.js gibt das Item selbst zurück.
    // Mehrere Zeilen: es kommt { items: [...] }.
    if (!daten) return [];
    if (Array.isArray(daten.items)) return daten.items;
    if (daten.id) return [daten];
    return [];
  }

  function euro(cent) {
    return Math.round((Number(cent) || 0)) / 100;
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (nachricht) {
    if (!nachricht || nachricht.source !== 'product-form') return;

    const artikel = zeilen(nachricht.cartData);
    if (!artikel.length) return;

    const posten = artikel.map(function (a) {
      return {
        item_id: String(a.product_id || ''),
        item_variant_id: String(a.variant_id || a.id || ''),
        item_name: a.product_title || a.title || '',
        item_variant: a.variant_title || '',
        item_sku: a.sku || '',
        price: euro(a.final_price != null ? a.final_price : a.price),
        quantity: Number(a.quantity) || 1,
      };
    });

    const wert = artikel.reduce(function (summe, a) {
      const zeile = a.final_line_price != null ? a.final_line_price : (a.price || 0) * (a.quantity || 1);
      return summe + euro(zeile);
    }, 0);

    // GA4-Konvention: den vorherigen Warenkorb-Inhalt leeren, damit sich
    // zwei Ereignisse nicht vermischen.
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      event_id: kennung(),
      mt_quelle: 'produktformular',
      mt_mehrzeilig: artikel.length > 1,
      ecommerce: {
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
        value: Math.round(wert * 100) / 100,
        items: posten,
      },
    });
  });
})();
